import PropTypes from 'prop-types'
import React from 'react'
import ConfirmDialog from '../../molecules/dialogs/ConfirmDialog'
import AcceptCloseModal from '../../molecules/dialogs/AcceptCloseModal'
import { useAuth } from '../../molecules/Auth'
import { roles } from '../../../configs/permissionsConfig'
import useCoordinatorCount from '../../../hooks/services/useCoordinatorCount'
import { changeRolDialogConfig } from '../../../configs/usersConfig'
import { isSuccessful } from '../../../hooks/useQuery'

function getDialogType(user, coordinatorCount) {
  const isBranchCoordinator = user.role === roles.branch_coordinator
  const isLastCoordinator = user.role === roles.coordinator && coordinatorCount?.count === 1

  if (isBranchCoordinator) return 'change_branch_coordinator'
  if (isLastCoordinator) return 'last_coordinator'
  return 'change_coordinator'
}

const DialogCoordinatorErrorMessage = ({ onClose, onConfirm, open, userEditId }) => {
  const { user } = useAuth()
  const { getCoordinatorCount } = useCoordinatorCount()
  const shouldRender = user.id === userEditId && [roles.coordinator, roles.branch_coordinator].includes(user.role)

  const { data: coordinatorCount, status } = getCoordinatorCount(
    ['coordinatorCount'],
    {},
    { enabled: shouldRender, refetchOnWindowFocus: true }
  )

  if (!isSuccessful(status)) return null

  const dialogType = getDialogType(user, coordinatorCount)
  const { title, content: Content, button } = changeRolDialogConfig[dialogType]

  return dialogType === 'last_coordinator' ? (
    <AcceptCloseModal open={open} onClose={onClose} onAccept={onClose} title={title} contentAlignment="left">
      <Content />
    </AcceptCloseModal>
  ) : (
    <ConfirmDialog
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      title={title}
      confirmLabel={button}
      primaryConfirmBtn
    >
      <Content />
    </ConfirmDialog>
  )
}

export default DialogCoordinatorErrorMessage

DialogCoordinatorErrorMessage.propTypes = {
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  open: PropTypes.bool,
  userEditId: PropTypes.number
}
